import { Component, Input } from '@angular/core';
import { SiteSearchResult } from 'src/app/api/site/siteSearchResult';

@Component({
  selector: 'site-search-result-item',
  standalone: false,
  templateUrl: './site-search-result-item.component.html',
  styleUrl: './site-search-result-item.component.css'
})
export class SiteSearchResultItemComponent {
  @Input() site: SiteSearchResult | null = null;
}
